/* Only for the unpublished Keller price-inquiry theme test. */
(function () {
  'use strict';
  var handleNode = document.getElementById('price-on-request-handles');
  var names = [];
  try { names = JSON.parse(handleNode ? handleNode.textContent : '[]'); } catch (e) {}
  var taggedHandles = new Set(names.filter(function (x) { return typeof x === 'string'; }));

  function productHandle(link) {
    if (!link) return '';
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    try { return match ? decodeURIComponent(match[1]) : ''; }
    catch (e) { return match ? match[1] : ''; }
  }
  function replacePrice(card, link) {
    var price = card.querySelector('.spf-product-card__price-wrapper') ||
                card.querySelector('.spf-product-card__price') ||
                card.querySelector('.spf-product__price') ||
                card.querySelector('.price');
    if (price && (price.textContent || '').trim() !== 'Preis auf Anfrage') {
      price.textContent = '';
      var label = document.createElement('span');
      label.className = 'price-on-request-text';
      label.textContent = 'Preis auf Anfrage';
      price.appendChild(label);
    }
    card.querySelectorAll('.unit-price, .spf-product-card__unit-price, .spf-product-card__price-per-unit, .spf-product-card__unitprice, .spf-product-card__unit_price').forEach(function (unit) {
      unit.hidden = true;
      unit.style.setProperty('display', 'none', 'important');
    });
    if (!card.querySelector('.price-on-request-link') && link) {
      var button = document.createElement('a');
      button.className = 'price-on-request-link button button--secondary';
      button.style.marginTop = '0.5rem';
      button.href = link.href.split('#')[0] + '#preis-anfrage';
      button.textContent = 'Preis anfragen';
      (price || card).insertAdjacentElement('afterend', button);
    }
    var buySelectors = [
      '.spf-product-card__add-cart',
      '.spf-product-card__addcart',
      '.spf-product-card__add-to-cart',
      '.spf-product-card__addtocart',
      '.spf-product-card__quick-add',
      'form[action*="/cart/add"]',
      'button[name="add"]'
    ];
    card.querySelectorAll(buySelectors.join(',')).forEach(function (button) {
      button.hidden = true;
      button.style.setProperty('display', 'none', 'important');
    });
    card.querySelectorAll('button, a').forEach(function (button) {
      if (button.classList.contains('price-on-request-link')) return;
      if (/in den warenkorb|add to cart|buy now|jetzt kaufen/i.test(button.textContent || '')) {
        button.hidden = true;
        button.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function updateGloboCards() {
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      var links = Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"]'));
      var link = links.find(function (a) { return taggedHandles.has(productHandle(a)); });
      if (!link && /(?:Weingut )?Klaus Peter Keller/i.test(card.textContent || '')) {
        link = links[0];
      }
      if (link) replacePrice(card, link);
    });
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      updateGloboCards();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }
  if (document.body) {
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  }
})();
